/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/st_xmin.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Extracts the minimum value of the `x` coordinates from the supplied geometry.
 * If the geometry is of type `geo_point` or `geo_shape` this is equivalent to extracting the minimum `longitude` value.
 *
 * @example
 * FROM airport_city_boundaries
 * | WHERE abbrev == "CPH"
 * | EVAL envelope = ST_ENVELOPE(city_boundary)
 * | EVAL xmin = ST_XMIN(envelope), xmax = ST_XMAX(envelope), ymin = ST_YMIN(envelope), ymax = ST_YMAX(envelope)
 * | KEEP abbrev, airport, xmin, xmax, ymin, ymax
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'st_xmin',
  signatures: [
    {
      params: [
        {
          name: 'point',
          type: 'cartesian_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'point',
          type: 'cartesian_shape',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'point',
          type: 'geo_point',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
    {
      params: [
        {
          name: 'point',
          type: 'geo_shape',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'double',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
